<template>
  <div @click="click">
    <svg-icon :icon-class="fullscreenSvg" class="screenfull-svg" />
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'Screenfull',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#48576a'
    }
  },
  data () {
    return {
      isFullscreen: false,
      fullscreenSvg: 'fullscreen'
    }
  },
  methods: {
    click () {
      if (!screenfull.enabled) {
        this.$inMessage({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      if (this.isFullscreen) {
        this.isFullscreen = false
        this.fullscreenSvg = 'fullscreen'
      } else {
        this.isFullscreen = true
        this.fullscreenSvg = 'exit-fullscreen'
      }
      screenfull.toggle()
    }
  }
}
</script>

<style scoped>
.screenfull-svg {
  display: inline-block;
  cursor: pointer;
  fill: #5a5e66;;
  width: 20px;
  height: 20px;
  vertical-align: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Screenfull/index.vue